import { IState } from '../../shared/models/state';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { GET_PROJECT_SUCCESS, GetProjectAction } from './projects.action';
import { Actions } from '@ngrx/effects';

@Injectable()
export class ProjectResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot) {
    const projectId = parseInt(route.params['projectId'], 10);
    this.store.dispatch(new GetProjectAction({ id: projectId }));
    return this.action$.ofType(GET_PROJECT_SUCCESS).take(1);
  }
}
